import React from 'react';
import getUnicodeFlagIcon from 'country-flag-icons/unicode';
import { UserLanguages } from '@cnx-saas/common';
import { SelectFieldProps, SelectField } from './Select';

export function SelectLanguage(
  props: SelectFieldProps<UserLanguages>,
): JSX.Element {
  const languages = [
    { code: UserLanguages.DE, label: 'Deutsch' },
    { code: UserLanguages.GB, label: 'English' },
    { code: UserLanguages.PL, label: 'Polski' },
  ];
  const options = languages.map((lang) => ({
    value: lang.code,
    label: (
      <div>
        {getUnicodeFlagIcon(lang.code)} {lang.label}
      </div>
    ),
  }));

  return <SelectField<UserLanguages> {...props} options={options} />;
}
